type TOptions<TValue> =
  | {
      /**
       * length of the array to create
       */
      length: number
      /**
       * value to fill the array with
       */
      value: TValue
      /**
       * mapping function to fill the array according to a pattern
       */
      mappingFunction?: undefined
    }
  | {
      length: number
      value?: undefined
      mappingFunction: (elementIndex: number) => TValue
    }

/**
 * Creates an array of a given `length` filled with elements of a given `value`.
 * You can also pass `mappingFunction` as a second argument.
 * Mapping function gets a current element's index and fills the array with returned value.
 */
export const createArray = <TValue>({ length, ...fillOptions }: TOptions<TValue>) => {
  if (fillOptions.mappingFunction) {
    return Array.from({ length }, (_, index) => fillOptions.mappingFunction(index))
  }

  return Array.from({ length }, () => fillOptions.value)
}
